import { useState } from "react";
import { toast } from "sonner";

export const useShareGenieLink = (url: string, title: string) => {
  const [sharing, setSharing] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Genie link copied");
    } catch {
      toast.error("Couldn't copy the link. Select the link below to copy it manually.");
    }
  };
  const share = async () => {
    if (sharing) return;
    setSharing(true);
    try {
      if (navigator.share) await navigator.share({ title, url });
      else await copy();
    } catch (error) {
      if (!(error instanceof Error && error.name === "AbortError")) await copy();
    } finally {
      setSharing(false);
    }
  };
  return { copy, share, sharing };
};
